import { OrderedMap, fromJS, Iterable, Map, List } from 'immutable';
import AssetRecord from 'Records/AssetRecord';
import AdStateRecord from 'Records/AdStateRecord';
import ComponentRecord from 'Records/ComponentRecord';
import KeyframeRecord from 'Records/KeyframeRecord';
import VariantRecord from 'Records/VariantRecord';
import ActiveFontRecord from 'Records/ActiveFontRecord';

export function reviveActiveFonts(activeFonts) {
  return new List(activeFonts.map(font => new ActiveFontRecord(font)));
}
/* eslint-disable consistent-return */
export function reviveAdStates(adStates) {
  return new OrderedMap(fromJS(adStates, (key, value) => {
    if (key === 'dimensions') { return value.toMap(); }
    if (key === 'viewport') { return value.toMap(); }
    if (key === 'components') { return value.toList(); }
    if (key === 'variants') { return value.toList(); }

    if (key !== '') {
      return new AdStateRecord({
        key: value.get('key'),
        name: value.get('name'),
        script: value.get('script'),
        dimensions: value.get('dimensions'),
        viewport: value.get('viewport'),
        offsetHeight: value.get('offsetHeight'),
        selected: value.get('selected'),
        components: value.get('components'),
        variants: value.get('variants'),
        backgroundColor: value.get('backgroundColor'),
        borderColor: value.get('borderColor'),
        borderWidth: value.get('borderWidth'),
        duration: value.get('duration'),
        loop: value.get('loop'),
        isBuildGuide: (value.get('name') === '$$IVO-BUILD-GUIDE$$'),
      });
    }
    const isIndexed = Iterable.isIndexed(value);
    return isIndexed ? value.toList() : value.toOrderedMap();
  }));
}
/* eslint-enable consistent-return */

/* eslint-disable consistent-return */
export function reviveVariants(adStates) {
  return new OrderedMap(fromJS(adStates, (key, value) => {
    if (key === 'dimensions') { return value.toMap(); }
    if (key === 'components') { return value.toList(); }

    if (key !== '') {
      return new VariantRecord({
        key: value.get('key'),
        name: value.get('name'),
        script: value.get('script'),
        dimensions: value.get('dimensions'),
        offsetHeight: value.get('offsetHeight'),
        selected: value.get('selected'),
        components: value.get('components'),
        backgroundColor: value.get('backgroundColor'),
      });
    }
    const isIndexed = Iterable.isIndexed(value);
    return isIndexed ? value.toList() : value.toOrderedMap();
  }));
}
/* eslint-enable consistent-return */

export function reviveComponents(components) {
  return new OrderedMap(fromJS(components, (key, value) => {

    if (key === 'keyframes') { return value.toList(); }
    if (key === 'settings') { return value.toMap(); }
    if (key === 'actions') { return value.toMap(); }
    if (key === 'currentStyle') { return value.toMap(); }
    if (key === 'assetIds') { return value.toList(); }
    if (key === 'subComponents') { return value.toList(); }

    if (key !== '') {
      return new ComponentRecord({
        currentStyle: value.get('currentStyle'),
        key: value.get('key'),
        uid: value.get('uid'),
        keyframes: value.get('keyframes'),
        settings: value.get('settings'),
        actions: value.get('actions'),
        type: value.get('type'),
        loop: value.get('loop'),
        subComponents: value.get('subComponents') || new List(),
      });
    }
    const isIndexed = Iterable.isIndexed(value);
    return isIndexed ? value.toList() : value.toOrderedMap();
  }));
}

export function reviveKeyframes(keyframes) {
  return new OrderedMap(fromJS(keyframes, (key, value) => {
    const ignoredAttributes = ['t', 'key', 'actions'];
    if (key !== '') {
      const keyframeStyle = value.reduce((r, v, k) => {
        if (!ignoredAttributes.includes(k)) { r[k] = v; } // eslint-disable-line no-param-reassign
        return r;
      }, {});

      const actions = keyframes[key] ? keyframes[key].actions : {};

      const hasLegacyRotation = keyframeStyle.rotation || keyframeStyle.rotationZ;
      if (!keyframeStyle.rotate && hasLegacyRotation) keyframeStyle.rotate = hasLegacyRotation;

      return new KeyframeRecord({
        t: value.get('t'),
        style: new Map(keyframeStyle),
        key: value.get('key'),
        actions: new Map(actions),
      });
    }
    const isIndexed = Iterable.isIndexed(value);
    return isIndexed ? value.toList() : value.toOrderedMap();
  }));
}

export function reviveAssets(assets) {
  return assets.map(asset => new AssetRecord({
    asset_url: asset.asset_url,
    file_size: asset.file_size,
    md5: asset.md5,
    id: asset.id,
    width: asset.width,
    height: asset.height,
    mime_type: asset.mime_type,
    name: asset.name,
    thumb_url: asset.thumb_url,
    fileName: asset.url_file_name,
  }));
}



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/records/revivers.js